import React, { useState } from 'react'
import Button from '../../../components/buttons/button'
import { Link, useNavigate } from 'react-router-dom'

const PrayerTimeType = () => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`/user-dashboard/prayer-times/type`)
    }

    return (
        <>
            <section className="py-4 px-4 w-full">
                <div className="w-full max-w-3xl mx-auto pt-3 pb-4 px-3">
                    <h2 className="text-center text-2xl font-medium text-slate-700 mb-8">
                        You wish to set:
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <Link to="/user-dashboard/prayer-times/athan" className="bg-white rounded-lg shadow-md p-8 hover:bg-slate-50 cursor-pointer transition-colors">
                            <div className="flex flex-col items-center space-y-4">
                                <div className="w-16 h-16 flex items-center justify-center">
                                    <svg className="w-12 h-12 text-slate-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M2 12a10 10 0 1 1 20 0c0 4.5-2.5 8-7 10l-3-6-3 6c-4.5-2-7-5.5-7-10z" />
                                        <path d="M12 3v2" />
                                        <path d="M12 19v2" />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-medium text-slate-600">Athan times</h3>
                            </div>
                        </Link>

                        <Link to="/user-dashboard/prayer-times/iqamah" className="bg-white rounded-lg shadow-md p-8 hover:bg-slate-50 cursor-pointer transition-colors">
                            <div className="flex flex-col items-center space-y-4">
                                <div className="w-16 h-16 flex items-center justify-center">
                                    <svg className="w-12 h-12 text-slate-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-medium text-slate-600">Iqamah times</h3>
                            </div>
                        </Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PrayerTimeType
